import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import { ComplexEntityTypes } from "../../../../../../utils/constants";
import { useEntities } from "../../../hooks/useEntities";
import EntityDrawer from "../../EntityDrawer/EntityDrawer";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const CLICKABLE_USER_STYLE = {
  cursor: "pointer",
  textDecoration: "underline",
};

const RelatedUserSection = ({ entityData, contextName }) => {
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false);
  const { trackEvent } = useAPI();
  const { useQueryForEntitiesByType } = useEntities();
  const { data: userEntities } = useQueryForEntitiesByType({
    type: ComplexEntityTypes.USER,
    enabled: Boolean(entityData?.connected_email),
  });
  const connectedUser = userEntities?.find(
    (user) => user.original_unique_id === entityData.connected_email
  );

  if (!connectedUser) {
    return null;
  }

  const onUserClick = () => {
    trackEvent(
      `User clicked on user ${entityData.connected_email}, from ${contextName} ${entityData?.display_name}`
    );
    setIsUserDrawerOpen(true);
  };

  return (
    <>
      <Box display={"flex"} flexDirection={"column"} gap={1}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography variant={"subtitle2"}>Related User</Typography>
        </Box>
        <Box display={"flex"} ml={2}>
          <TextIntegrationStyle
            title={""}
            value={entityData.connected_email}
            onClick={onUserClick}
            style={CLICKABLE_USER_STYLE}
            tooltipTitle="Click to view user details"
          />
        </Box>
      </Box>
      <EntityDrawer
        openDrawer={isUserDrawerOpen}
        selectedEntity={connectedUser}
        onClose={() => {
          setIsUserDrawerOpen(false);
        }}
      />
    </>
  );
};

export default RelatedUserSection;
